import { Button, DatePicker, Input, Select } from "antd";

import React, { useEffect, useState } from "react";
import "../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  GetPaymentModes,
  GetVendorUnpaidOrders,
  RegisterPayment,
  GetDepositPaymentMethodBalance, // ADD THIS import to your API functions file
} from "../API  Functions/PurchaseFunctions";
import { toast } from "react-toastify";
import moment from "moment";
import LoadingSpinner from "../components/Loading";
import i18next from "i18next";

const styles = {
  selectant: {
    border: "none",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
  },
  container: {
    padding: "30px",
    borderRadius: "18px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: "25px",
    fontWeight: "bold",
    textAlign: "left",
  },
  cancelIcon: {
    cursor: "pointer",
  },
  description: {
    textAlign: "left",
    fontSize: "16px",
    color: "#272728",
    marginTop: "10px",
  },
  input: {
    width: "100%",
    height: "5vh",
    borderRadius: "5px",
    marginBottom: "4px",
    boxSizing: "border-box",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    width: "180px",
    height: "42px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    marginRight: "10px",
  },
  confirmButton: {
    backgroundColor: "primaryBlue",
    color: "#FFFFFF",
  },
  cancelButton: {
    backgroundColor: "#CCCCCC",
    color: "#000000",
  },
  note: {
    color: "primaryBlue",
    marginTop: "20px",
    textAlign: "left",
  },
};

const PurchasePayment = ({
  isOpen,
  onClose,
  bill_id,
  page,
  due_amount,
  Popup,
  totalAmount,
  billDiscountPer,
  billDiscountVal,
  totalVatVal,
  selectedPaymentTerm,
  vendor_id,
  onPaymentSuccess,
  store_id, // ADD THIS PROP — needed for balance check API
}) => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector((state) => state?.login?.user?.result?.company_id);

  const { Option } = Select;

  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(t("select"));
  const [restricted, setrestricted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentMode, setPaymentMode] = useState([]);
  const [amount, setAmount] = useState("");
  const [paymentDate, setPaymentDate] = useState(null);
  const [amountError, setAmountError] = useState("");
  const [cashId, setCashId] = useState(null);
  const [bankId, setBankId] = useState(null);
  const [unpaidOrders, setUnpaidOrders] = useState([]);
  const [selectedOrderAmount, setSelectedOrderAmount] = useState(null);

  // --- NEW STATE ---
  const [methodBalance, setMethodBalance] = useState(null);       // balance from GetDepositPaymentMethodBalance
  const [showDepositField, setShowDepositField] = useState(false); // whether to show deposit input
  const [depositAmount, setDepositAmount] = useState("");           // deposit amount (auto-filled, editable)
  const [remark, setRemark] = useState("");                         // remark field
  const [selectedBankId, setSelectedBankId] = useState(null);      // bank_id from selected journal
  const [balanceLoading, setBalanceLoading] = useState(false);     // loading state for balance check

  const totalBillAmount =
    totalAmount -
    ((billDiscountPer / 100) * totalAmount + parseFloat(billDiscountVal || 0)) +
    totalVatVal;

  const handleAmountChange = (e) => {
    const value = e.target.value;

    setAmountError("");

    if (value < 0) {
      setAmountError(t("Amount cannot be negative."));
    } else if (value > totalBillAmount) {
      setAmountError(
        t(`Amount cannot exceed the due amount of ${totalBillAmount}`)
      );
    } else if (value > selectedOrderAmount && page === "allVendors") {
      setAmountError(`${t("Amount cannot exceed the due amount of")} ${selectedOrderAmount}`);
    } else {
      setAmount(value);
    }

    if (
      value > due_amount &&
      !(selectedPaymentTerm === "Immediate Payment" || selectedPaymentTerm === "الدفع الفوري")
    ) {
      setAmountError(t(`Amount cannot exceed the due amount of ${due_amount}`));
    }

    // --- RE-CHECK DEPOSIT whenever amount changes ---
    // Only re-evaluate if a payment mode is already selected and we have a balance
    if (selectedPaymentMode !== null && methodBalance !== null) {
      const numericValue = parseFloat(value) || 0;
      if (numericValue > methodBalance) {
        const remaining = (numericValue - methodBalance).toFixed(2);
        setDepositAmount(remaining);
        setShowDepositField(true);
      } else {
        setDepositAmount("");
        setShowDepositField(false);
      }
    }
  };

  const handleDateChange = (date, dateString) => {
    setPaymentDate(dateString);
  };

  // --- UPDATED: handleSelectChange now also fetches balance ---
  const handleSelectChange = async (index) => {
    const selectedJournal = paymentMode[index];

    setSelectedPaymentMode(index); // store index for Select display
    setShowDepositField(false);
    setDepositAmount("");
    setMethodBalance(null);

    const journalBankId = selectedJournal?.bank_id || null;
    const journalName = selectedJournal?.name || null;
    setSelectedBankId(journalBankId);

    if (!selectedJournal || !store_id) return;
    const shouldFetchBalance =
      selectedJournal?.name === "Cash" ||
      selectedJournal?.name === "Bank" ||
      !!selectedJournal?.bank_id;

    if (!shouldFetchBalance) return;


    setBalanceLoading(true);
    try {
      const balancePayload = { store_ids: [store_id], from_type: journalBankId ? journalBankId : journalName };
      const balanceResult = await GetDepositPaymentMethodBalance(balancePayload);
      const balance = balanceResult?.result?.balance ?? null;
      setMethodBalance(balance);

      const currentAmount = parseFloat(amount) || 0;
      if (balance !== null && currentAmount > balance) {
        const remaining = (currentAmount - balance).toFixed(2);
        setDepositAmount(remaining);
        setShowDepositField(true);
      }
    } catch (error) {
      console.error("Error fetching payment method balance:", error);
      setMethodBalance(null);
    } finally {
      setBalanceLoading(false);
    }
  };

  const handleOrderChange = (value) => {
    const selectedOrderItem = unpaidOrders.find((order) => order.order_id === value);

    if (selectedOrderItem) {
      setAmount(selectedOrderItem.amount_due || "");
      setSelectedOrderAmount(selectedOrderItem?.amount_due);
    }

    setSelectedOrder(selectedOrderItem?.bill_id);
  };

  const fetchPaymentMethods = () => {
    GetPaymentModes(user_id)
      .then((result) => {
        if (Array.isArray(result?.data?.result?.journals)) {
          setPaymentMode(result.data.result.journals);

          // Set IDs for Cash and Bank (Cash has no bank_id, banks have bank_id)
          const cashMode = result.data.result.journals.find(
            (item) => item.name === "Cash"
          );
          // For backward compat — keep first bank found as default bankId
          const bankMode = result.data.result.journals.find(
            (item) => item.bank_id !== undefined
          );

          if (cashMode) setCashId(cashMode.id);
          if (bankMode) setBankId(bankMode.id);
        } else {
          console.error(
            "Expected an array but got:",
            result?.data?.result?.journals
          );
          setPaymentMode([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching payment methods:", error);
        setPaymentMode([]);
      });
  };

  const fetchOrders = () => {
    GetVendorUnpaidOrders(company_id, vendor_id)
      .then((result) => {
        if (Array.isArray(result?.data?.result?.response)) {
          setUnpaidOrders(result.data.result.response);
        } else {
          console.error(
            "Expected an array but got:",
            result?.data?.result?.response
          );
          setUnpaidOrders([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching payment methods:", error);
        setUnpaidOrders([]);
      });
  };

  useEffect(() => {
    if (user_id) {
      fetchPaymentMethods();
    }
    if (page === "allVendors" && vendor_id) {
      fetchOrders();
    }
  }, [user_id]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!paymentDate || !amount) {
      return;
    }

    setrestricted(true);
    setLoading(true);

    const payload = {
      ...(page === "createOrder" && { order_id: bill_id }),
      ...(page === "allVendors" && { bill_id: selectedOrder }),
      ...(page !== "createOrder" && page !== "allVendors" && { bill_id: bill_id }),

      paid_amount: Number(amount),
      payment_date: paymentDate,
      journal_id: paymentMode[selectedPaymentMode]?.id,
      vendor_id: Number(vendor_id),
      lang: i18next.language === "ar" ? "ar_001" : "en_US",

      // --- NEW FIELDS (only include if deposit flow is active) ---
      ...(showDepositField && depositAmount && {
        deposit_amount: Number(depositAmount),
      }),
      ...(remark && {
        remark:
          page === "allVendors"
            ? `${remark} - ${unpaidOrders?.find(
              (item) => item.bill_id === selectedOrder
            )?.order_number || ""
            }`
            : remark,
      }),
      ...(selectedBankId && { bank_id: selectedBankId }),
    };

    console.log("PAYLOAD", payload);

    RegisterPayment(payload).then((response) => {
      if (response?.status === "Payment Registered") {
        if (onPaymentSuccess) {
          onPaymentSuccess();
        }
        toast.success(t("Payment registered Successfully"));
        fetchOrders(); // Refresh orders to reflect payment
        setAmount("");
        setAmountError("");
        setDepositAmount("");
        setShowDepositField(false);
        setRemark("");
        setSelectedBankId(null);
        setMethodBalance(null);
        setLoading(false);
        Popup();
      }
    });

    onClose();
  };


  useEffect(() => {
    if (
      totalBillAmount &&
      (selectedPaymentTerm === "Immediate Payment" ||
        selectedPaymentTerm === "الدفع الفوري")
    ) {
      setAmount(totalBillAmount);
      setAmountError("");
    } else if (due_amount) {
      setAmount(due_amount);
      setAmountError("");
    }
  }, [totalBillAmount, selectedPaymentTerm, due_amount]);

  // Determine if Done button should be enabled
  const isDoneEnabled =
    paymentDate &&
    amount &&
    !amountError &&
    selectedPaymentMode !== null &&
    !balanceLoading &&
    // If deposit field is showing, deposit amount must be filled
    (!showDepositField || (showDepositField && depositAmount && remark));

  return (
    <>
      {loading && <LoadingSpinner />}

      {isOpen && (
        <>
          <div style={styles.overlay} onClick={onClose}></div>
          <div style={styles.container} className="w-full md:w-[50%]">
            <div style={styles.header}>
              <p style={styles.title}>{t("Add Payment")}</p>
            </div>

            <div className="justify-content-center align-items-center">
              <form onSubmit={handleSubmit}>
                {page === "allVendors" && (
                  <>
                    <p className=" mb-2 mt-2">{t("Select Order")}</p>
                    <Select
                      showSearch
                      style={styles.input}
                      placeholder={t("select")}
                      value={setSelectedOrder.order_number}
                      onChange={handleOrderChange}
                      filterOption={(input, option) => {
                        const children = option?.children?.toString()?.toLowerCase() || '';
                        return children.includes(input.toLowerCase());
                      }}
                    >
                      <Option value="select" disabled>
                        {t("select")}
                      </Option>
                      {unpaidOrders.map((item) => (
                        <Option key={item.order_id} value={item.order_id}>
                          {t(item.order_number)} ({`EGP ${item.amount_due}`})
                        </Option>
                      ))}
                    </Select>
                  </>
                )}

                {/* Date Selection Field */}
                <p className="mb-2 mt-2">{t("Payment Date")}</p>
                <DatePicker
                  style={styles.input}
                  onChange={handleDateChange}
                  placeholder={t("Select Payment Date")}
                  disabledDate={(current) =>
                    current && current > moment().endOf("day")
                  }
                />

                {/* Amount Input Field */}
                <p className="mb-2 mt-2">{t("amount")}</p>
                <Input
                  style={styles.input}
                  value={amount}
                  onChange={handleAmountChange}
                  placeholder={t("Enter Amount")}
                  type="number"
                  step="0.01"
                  disabled={
                    totalBillAmount &&
                    (selectedPaymentTerm === "Immediate Payment" ||
                      selectedPaymentTerm === "الدفع الفوري")
                  }
                  min={0}
                  maxLength={7}
                />
                {amountError && (
                  <p className="text-red text-xs mb-4">{amountError}</p>
                )}

                {/* Payment Mode */}
                <p className="mb-2 mt-2">{t("Payment Mode")}</p>
                <Select
                  style={styles.input}
                  placeholder={t("select")}
                  value={selectedPaymentMode}
                  onChange={handleSelectChange}
                  loading={balanceLoading}
                  disabled={amount == ''}
                >
                  {paymentMode.map((item, index) => (
                    <Option key={index} value={index}>
                      {t(item.name)}
                    </Option>
                  ))}
                </Select>

                {/* Balance info hint */}
                {methodBalance !== null && !balanceLoading && (
                  <p className="text-xs mt-1 mb-2" style={{ color: "#6b7280" }}>
                    {t("Available Balance")}: {methodBalance}
                  </p>
                )}

                {/* --- DEPOSIT FIELD: shown when amount > method balance --- */}
                {showDepositField && (
                  <>
                    <p className="mb-2 mt-3 font-semibold" style={{ color: "#e65c00" }}>
                      {t("Deposit Amount")}
                      <span className="text-xs font-normal ml-2" style={{ color: "#6b7280" }}>
                        ({t("Remaining amount to be deposited")})
                      </span>
                    </p>
                    <Input
                      style={styles.input}
                      value={depositAmount}
                      onChange={(e) => setDepositAmount(e.target.value)}
                      placeholder={t("Enter Deposit Amount")}
                      type="number"
                      readOnly
                      step="0.01"
                      min={0}
                    />

                    {/* Remark field */}
                    <p className="mb-2 mt-3">{t("Remark")}</p>
                    <Input
                      style={styles.input}
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      placeholder={t("Enter Remark")}
                    />
                  </>
                )}

                <div className="flex flex-row items-center justify-center mb-4"></div>

                <div className="flex justify-center mt-5">
                  <button
                    className="w-52 h-10 border-primaryBlue border text-primaryBlue text-sm font-semibold rounded-lg me-5"
                    onClick={onClose}
                    type="button"
                  >
                    {t("close")}
                  </button>
                  <button
                    type="submit"
                    className={`w-52 h-10 ${isDoneEnabled ? "bg-primaryBlue" : "bg-primaryBluedisabled"
                      } text-white text-sm font-semibold rounded-lg`}
                    disabled={!isDoneEnabled}
                  >
                    {t("Done")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PurchasePayment;